// extracted by mini-css-extract-plugin
module.exports = {"dark-theme":"ForgotPassword_dark-theme_22n60","bold":"ForgotPassword_bold_35o6k"};